module.exports = __webpack_public_path__ + "img/icon_wechat@2x.7fe68bd6.png";